import { Utils } from "@/plugins/utils"
import router from "@/router"

export default {
	namespaced: true,
	state: {
		lstCfa: [],
		cfa: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
	},
	getters: {
		getCfa: state => {
			let cfa = { ...state.cfa }
			cfa.cfaocupa = new String(cfa.cfaocupa ?? "")
			cfa.cfaident = new String(cfa.cfaident ?? "")
			cfa.cfafilia = new String(cfa.cfafilia ?? "")
			cfa.cfanasc = cfa.cfanasc ? Utils.ParseToDate(cfa.cfanasc) : new Date(1900, 1, 1)
			return cfa
		},
	},
	mutations: {
		set(state, cfa) {
			state.cfa = cfa
			state.cfa.cfanasc = new Date(cfa.cfanasc).toLocaleString(navigator.language, {
				year: "numeric",
				month: "2-digit",
				day: "2-digit",
			})
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.cfa = null
		},
		setParamsDataTable(state, payload) {
			state.lstCfa = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setInsert(state, payload) {
			state.insert = payload
			state.update = !payload
			state.cfa = {
				cfacliente: "",
				cfafilia: "",
				cfaocupa: "",
				cfaconjuge: "",
				cfaident: "",
				cfanasc: "",
			}
		},
		setUpdate(state, payload) {
			state.update = payload
			state.insert = !payload
		},
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		setInsert({ commit }, payload) {
			commit("setInsert", payload)
		},
		setUpdate({ commit }, payload) {
			commit("setUpdate", payload)
		},
		async get(store, { cfacliente, silent }) {
			return await this._vm.$axios
				.get(`/Customer/PersonalData/Find/${cfacliente}?silent=${silent}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
		},
		async find(store, { cfacliente, silent = false }) {
			store.state.loading = true
			store.commit("initForm")
			await store
				.dispatch("get", { cfacliente, silent })
				.then(async cfa => {
					if (cfa) {
						store.commit("set", cfa)
						store.commit("setUpdate", true)
						return cfa
					}
					store.commit("set", {
						cfacliente: cfacliente,
						cfaconjuge: "",
						cfaocupa: "",
						cfaident: "",
						cfafilia: "",
						cfanasc: new Date(1900, 1, 1),
					})
					await store.dispatch("insert", false)
					await store.dispatch("find", { cfacliente, silent })
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			store.state.loading = false
			return true
		},
		save(store, cfacliente) {
			if (cfacliente) {
				store.state.cfa.cfacliente = cfacliente
			}

			if(store.state.cfa.cfacliente == null || store.state.cfa.cfacliente == undefined){
				store.dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: "Cliente não informado para registro de dados pessoais",
					},
					{ root: true },
				)
			}

			if (store.state.update) {
				store.dispatch("update", cfacliente == null)
				return
			}

			store.dispatch("insert", cfacliente == null)
		},
		async insert(store, redirect = true) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.post("/Customer/PersonalData/Insert", store.getters.getCfa)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					if (redirect)
						router.push("/oryxpdv/dados-pessoais")
					store.state.cfa = null
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async update(store, redirect = true) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.put("/Customer/PersonalData/Update", store.getters.getCfa)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					if (redirect)
						router.push("/oryxpdv/dados-pessoais/")
					store.state.cfa = null
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async delete(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.delete(`/Customer/PersonalData/Delete/${store.state.cfa.cfacliente}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/dados-pessoais")
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async findList(store, cfacliente) {
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios
				.get(`/Customer/PersonalData/FindList/${cfacliente}`)
				.then(response => {
					let lstCfa = Utils.ValidateAxiosResponse(response.data)
					store.state.lstCfa = lstCfa
					store.state.hasNext = lstCfa.length > store.state.itemsPerPage
				})
				.catch(error => {
					store.state.lstCfa = []
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.state.loading = false
		},
		async search(store, { limit = 20, page = 1 }) {
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios
				.get(`/Customer/PersonalData/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					store.commit("setParamsDataTable", payload)
					return true
				})
				.catch(error => {
					store.state.lstCfa = []
					store.state.search = ""
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.state.loading = false
			return payload
		},
	},
}
